goog.require('el8.data.practiceUsers');

goog.require('el8.app.setup');
goog.require('el8.app.shared.dialog.survey');
goog.require('el8.app.shared.dialog.plr4EveryoneFirstSignInFTUX');
goog.require('el8.app.shared.dialog.vipPatientAccessConfirmation');
goog.require('el8.apphome.docMgr.main');
goog.require('el8.apphome.layout');
goog.require('el8.apphome.navtriggers');
goog.require('el8.apphome.reqAct.main');
goog.require('el8.apphome.scheduler.dialog.apptDetails');
goog.require('el8.apphome.scheduler.dialog.confirmRecurringEvent');
goog.require('el8.appservice.highlighter');
goog.require('el8.appservice.notifier');
goog.require('el8.appservice.search');
goog.require('el8.appshared.message');
goog.require('el8.appshared.newMessage');
goog.require('el8.data.base');
goog.require('el8.data.staffGroups');
goog.require('el8.data.visitNoteTypes');
goog.require('el8.practicedata.unfiledInboxes');
goog.require('el8.service.urls');
goog.require('el8.tourguide.onboardHome');
goog.require('el8.tourguide.passportHome');
goog.require('el8.util.base');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.apphome = {};

el8.main.apphome.init = function(spec) {

    spec['layout'] = {innerContainerSelector: '#refBoard'};
    el8.app.setup(spec);

    // pass the data that's available on page load into the redux store right away
    el8React.configureStore(spec.data);
    // render the react insurance dialog
    el8React.render.insuranceDialog('insurance-dialog-container');
    el8React.render.practiceHomeToolbar('main-toolbar');
    el8React.render.dialogs('react-dialogs-container');
    el8React.render.practiceHomePatientSearch('chart-home-patient-search');
    el8React.render.findChartHeaderButton('react-chartnav');

    if (el8Globals['ONBOARDING']) {
        el8.tourguide.onboardHome.init();
    }

    if (el8Globals['PASSPORT_EMR']) {
        el8.tourguide.passportHome.init();
    }

    el8.util.consts.DEFAULT_SCHEDULE_TIME = el8.service.tz.newTzTime(9, 0, 0);

    el8.apphome.navtriggers.setup(); // needs to come before loading unfiledInboxes

    el8.appshared.message.init(el8.appshared.newMessage);

    el8.apphome.docMgr.main.initNavMenu();

    el8.apphome.reqAct.main.init();

    // Need to happen before layout setup in order for the html to be populated
    ReactDOM.render(
      el8React.createScheduler({
          defaultView: 'day'
      }),
      document.querySelector('#refBoard.react-single-day-scheduler-container')
    );

    el8.apphome.layout.setup();

    // Set 60min interval to be refreshing requiring actions
    var reqActIntId = null;
    function setReqActInterval() {
        reqActIntId = $.el8_setInterval("el8.apphome.reqAct.main.refreshAllQueues()", 1000*60*60);
    }
    setReqActInterval();

    if (el8Globals.FEATURES.UserSurveys) {
        // Set 20min interval to check for deferrable notifications (like surveys)
        $.el8_setInterval("el8.app.shared.dialog.survey.poll()", 1000*60*20);
        el8.app.shared.dialog.survey.poll(); // check once immediately
    }

    if (el8.util.getUrlParam('newChartDialog')) {
        el8.appshared.dialog.createPatient.show();
    }

    /**
     * Handles FTUE for PLR4Everyone
     * Currently feature sealed off until fully implemented/tested.
     */
    if (el8Globals.FEATURES.PLR4Everyone) {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('ftue', [el8.data.currUser.getId(),'PLR4Everyone']),
            success: function(res) {
                if (!res.data) {
                    if (el8.data.currPractice.isPracticingEmr()) {
                        if (!el8.data.practiceSettings.isHasSetAutoShareStatus() && !el8.data.currUser.isPracticeAdmin() ) {
                            // if practice hasn't set auto share status and user isn't an admin, we don't do anything
                            // currently since we need admin to pick a state first
                        } else {
                            el8.app.shared.dialog.plr4EveryoneFirstSignInFTUX.show();
                        }
                    } else {
                        el8.app.shared.dialog.plr4EveryoneFirstSignInFTUX.show();
                    }
                }
            }
        });
    }

    /**
     * Load metadata we will find useful
     */
    el8.data.premadeMessages.load(null, true); // async load
};
